const common = require('./common');
const env = require("../../config.js").default;

export function saveCheckout(wishList){
    //debugger
    if(wishList !== undefined && wishList !== null && wishList.length > 0){
        getCartId().then((cartId) => {
            addToCart(cartId, wishList);
        });
    }
}

function addToCart(cart_id, wishList){
    var data = {items: []};
    for (var i = 0; i < wishList.length; i++) {
        data['items'].push({ "brand": wishList[i].marca, "part_number": wishList[i].carti, "description": wishList[i].darti, "quantity": wishList[i].qpezzi, "currency": wishList[i].cvalu, "price": wishList[i].price });
    }
    common.apiCall(env.BACKEND + 'cart/' + cart_id + '/', 'PATCH', data, true).then((checkout) => {
        console.log("Checkout", checkout)
    });
}

function getCartId(){
    let cart_id = common.get_localStorage("cart_id");
    if (cart_id !== undefined && cart_id !== null && cart_id !== "") {
        return Promise.resolve(cart_id);
    }

    return common.apiCall(env.BACKEND + 'cart/', 'POST', {}, true).then((cart) => {
        if(cart === undefined || cart.id === undefined)
            return false;
        common.set_localStorage("cart_id", cart.id);
        return cart.id;
    });
}

export function isCartByFrameMessage() {
    let cart_by_frame_message = common.get_localStorage("cart_by_frame_message");
    return (common.inIframe() && cart_by_frame_message !== undefined && cart_by_frame_message !== null && cart_by_frame_message);
}